import { useMemo } from 'react';
import { useTicketsSelected, useSummary } from '@/store';
import useTrackingCore from './core';
import { compose } from '@/utils/compose';

/**
 * Eventos de tracking relacionados con tickets
 * @returns {Object} Funciones de tracking específicas para tickets
 */

export default function useTicketsTracking() {
  const {
    trackEventWithCurrency,
    trackEventWithTotalPrice,
    trackEventWithCouponAndPaymentConfig,
    trackEventWithCouponCurrencyAndPrice,
    trackLeavePageEvent,
  } = useTrackingCore();

  const { count, ticketTypesCategoriesSelecteds } = useTicketsSelected();
  const {
    summary: { total_to_pay },
  } = useSummary();

  const ticketTrackingFunctions = useMemo(() => {
    const withZoneData = (trackFn) => {
      return (zoneData) => {
        const { zoneId, zoneName, quantity } = zoneData;
        trackFn({
          zone_id: zoneId,
          zone_name: zoneName,
          selected_ticket_quantity: quantity,
        });
      };
    };

    const createZoneEventTracker = (eventName) => {
      return withZoneData((zoneData) =>
        trackEventWithTotalPrice(eventName, zoneData),
      );
    };

    const createZonePriceTracker = (eventName) => {};

    return {
      ticketSelectionViewed: () => {
        // Se deshabilita temporalmente el evento
        // trackEventWithCouponAndPaymentConfig('tickets_selection_viewed', {});
      },
      buyTicketsClicked: () => {
        trackEventWithCouponCurrencyAndPrice('buy_tickets_clicked', {
          selected_tickets: count,
          selected_ticket_types: ticketTypesCategoriesSelecteds(),
        });
      },
      selectionAbandoned: (reason = 'manual_exit') => {
        trackLeavePageEvent('selection_abandoned', {
          selected_tickets: count,
          reason,
        });
      },
      mapZoneSelected: createZoneEventTracker('map_zone_selected'),
      listTicketQuantityChanged: () => {},
      // Se deshabilita temporalmente el evento
      // listTicketQuantityChanged: createZoneEventTracker(
      //  'list_ticket_quantity_changed',
      // ),
      mapSeatSelected: ({ zoneId, zoneName, seatId, seatNumber }) => {
        // Se deshabilita temporalmente el evento
        // trackEventWithCurrency('map_seat_selected', {
        //   zone_id: zoneId,
        //   zone_name: zoneName,
        //   seat_id: seatId,
        //   seat_number: seatNumber,
        // });
      },
    };
  }, [
    trackEventWithTotalPrice,
    trackLeavePageEvent,
    // trackEventWithCouponAndPaymentConfig,
    trackEventWithCouponCurrencyAndPrice,
    count,
    ticketTypesCategoriesSelecteds,
    // trackEventWithCurrency,
  ]);

  return ticketTrackingFunctions;
}
